import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  CanActivateFn,
} from '@angular/router';
import { WHLoginDataService } from '@workheld/workheld-shared-lib';

export const NO_PERMISSIONS_ROUTE = 'no-permissions';
export const NO_PERMISSIONS_ATTEMPTED_PATH_PARAM = 'attemptedPath';

export const FeatureKeyGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const loginDataService = inject(WHLoginDataService);

  const redirectToNoPermissions = () =>
    router.navigate([`/${NO_PERMISSIONS_ROUTE}`], {
      queryParams: { [NO_PERMISSIONS_ATTEMPTED_PATH_PARAM]: state.url },
    });

  const canActivate = route?.data?.featureKey
    ? loginDataService.featureConfigMap$.value.get(route?.data?.featureKey)
    : true;

  if (!canActivate) {
    await redirectToNoPermissions();
    return false;
  }

  const permissionKey = route?.data?.permissionKey;
  const permissionKeys = route?.data?.permissionKeys;

  if (!permissionKey && !permissionKeys) {
    return true;
  }

  const hasPermission = permissionKey
    ? loginDataService.checkPermission(permissionKey)
    : false;
  const hasAnyPermission =
    Array.isArray(permissionKeys) && permissionKeys.length > 0
      ? loginDataService.checkPermissions(permissionKeys)().some(Boolean)
      : false;

  if (!hasPermission && !hasAnyPermission) {
    await redirectToNoPermissions();
  }

  return hasPermission || hasAnyPermission;
};
